import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-set",
    styleUrls: ["./set.component.scss"],
    templateUrl: "./set.component.html"
})
export class FUISetComponent {
    @Input() title: string;
    @Input() i18nParams: any = {};
}
